
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/osrodek-narciarski",
      function () {
        return require("private-next-pages/osrodek-narciarski.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/osrodek-narciarski"])
      });
    }
  